import { View } from 'okta';
import hbs from 'handlebars-inline-precompile';


export default View.extend({
  className: 'consent-description detail-row',
  template: hbs(
    '\
      <p>{{i18n code="consent.required.description" bundle="login"}}</p>\
    '
  )
});



// WEBPACK FOOTER //
// ./src/v2/view-builder/views/consent/EnduserConsentAgreementText.js